var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7718_743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#0059A9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4404 39.5387V47.7292C48.1187 48.1172 47.6218 48.5383 46.9499 48.9926C46.278 49.4373 45.4121 49.8206 44.3522 50.1424C43.2923 50.4641 42.0101 50.625 40.5054 50.625C39.1711 50.625 37.955 50.4073 36.8573 49.972C35.7595 49.5272 34.8132 48.879 34.0182 48.0273C33.2328 47.1756 32.6271 46.1346 32.2013 44.9044C31.7754 43.6647 31.5625 42.2499 31.5625 40.6601V39.3683C31.5625 37.7785 31.766 36.3637 32.1729 35.124C32.5893 33.8843 33.1807 32.8386 33.9473 31.9869C34.7138 31.1352 35.627 30.4869 36.6869 30.0422C37.7468 29.5974 38.925 29.375 40.2215 29.375C42.0195 29.375 43.4958 29.6684 44.6503 30.2551C45.8049 30.8324 46.685 31.6367 47.2906 32.6683C47.9057 33.6903 48.2843 34.8638 48.4262 36.1886H44.2955C44.1914 35.4883 43.9926 34.878 43.6993 34.3575C43.4059 33.837 42.9848 33.4301 42.4359 33.1367C41.8965 32.8433 41.1962 32.6966 40.335 32.6966C39.6253 32.6966 38.9912 32.8433 38.4329 33.1367C37.884 33.4206 37.4203 33.8417 37.0418 34.4C36.6633 34.9584 36.3746 35.6492 36.1759 36.4725C35.9772 37.2958 35.8778 38.2516 35.8778 39.3399V40.6601C35.8778 41.7389 35.9819 42.6947 36.1901 43.5275C36.3983 44.3508 36.7058 45.0463 37.1128 45.6141C37.5292 46.1725 38.0402 46.5936 38.6458 46.8775C39.2515 47.1614 39.9565 47.3034 40.7609 47.3034C41.4328 47.3034 41.9911 47.2466 42.4359 47.133C42.8902 47.0195 43.2545 46.8822 43.5289 46.7214C43.8128 46.551 44.0305 46.3901 44.1819 46.2387V42.5764H40.2925V39.5387H48.4404Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7718_743",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7718_743"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7718_743",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrow);
export default __webpack_public_path__ + "static/media/LogoGrow.fe6b9dc7c5121d18a96cc48d8699aacc.svg";
export { ForwardRef as ReactComponent };